import axios, { AxiosPromise } from "axios";
import { env } from "../env/env";
import Storage from "../util/Storage";
import { LinkPageDto } from "../domain/LinkPageDto";

export function getLpBasePath() {
  if (window.location.hostname.match("staging.mhmfun.com")) return "https://stage.mhme.nu";
  if (window.location.hostname.match("musthavemenus.com")) return "https://ohbz.com";

  return env.basePath;
}

const LinkPagesApi = {
  getPages(locationId: number): AxiosPromise<LinkPageDto[]> {
    return axios.get(
      `${getLpBasePath()}${env.lpContextPath}/api/v1/landing-pages`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
        params: {
          locationId: locationId,
          published: false,
        },
      }
    );
  },

  removeLandingPage(id: string) {
    return axios.delete(
      `${getLpBasePath()}${env.lpContextPath}/api/v1/landing-pages/${id}`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  moveToLocation(id: string, locationId: number) {
    return axios.put(
      `${getLpBasePath()}${env.lpContextPath}/api/v1/landing-pages/transfer?landingPageId=${id}&newLocationId=${locationId}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  renameLinkPage(id: String, newName: String): AxiosPromise<LinkPageDto> {
    return axios.post(
      `${getLpBasePath()}${env.lpContextPath}/api/v1/landing-pages/rename-dashboard?landingPageId=${id}&newName=${newName}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },
};

export default LinkPagesApi;
